export default {
  serviceInfo: {},
};
